import {
  OrderDirection,
  OrderType,
  SpotOrderTypeFilterEnum,
} from 'store/spot/types'
import { Ether } from 'types'

export function getStopOrderTriggerDirection(
  stopPrice: Ether | number,
  lastPrice: Ether | number,
): OrderDirection {
  if (Number(stopPrice) > Number(lastPrice)) {
    return OrderDirection.LONG
  } else {
    return OrderDirection.SHORT
  }
}

// export enum StopOrderType {
//   TakeProfit = 'Take Profit',
//   StopLimit = 'Stop Limit',
//   TakeProfitMarket = 'Take Profit Market',
//   StopMarket = 'Stop Market',
// }
export function getStopOrderType(
  orderType: OrderType,
  orderDirection: OrderDirection,
  triggerDirection: OrderDirection,
) {
  let stopDirection: OrderDirection
  if (triggerDirection === OrderDirection.LONG) {
    stopDirection =
      orderDirection === OrderDirection.LONG
        ? OrderDirection.SHORT
        : OrderDirection.LONG
  } else {
    stopDirection =
      orderDirection === OrderDirection.LONG
        ? OrderDirection.LONG
        : OrderDirection.SHORT
  }

  if (orderType === OrderType.LIMIT) {
    return stopDirection === OrderDirection.LONG
      ? SpotOrderTypeFilterEnum.TakeProfitLimit
      : SpotOrderTypeFilterEnum.StopLimit
  } else {
    return stopDirection === OrderDirection.LONG
      ? SpotOrderTypeFilterEnum.TakeProfitMarket
      : SpotOrderTypeFilterEnum.StopMarket
  }
}
